import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { FileUploadDto } from "../../../core/models/shared/fileUploadDto";
import { LoaderService } from "../../../core/services/loader.service";
import { ProjectWorkflowService } from "../../../core/services/project-workflow.service";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { CommonModule } from "@angular/common";
import { FileUploadModule } from "primeng/fileupload";
import { FormsModule } from "@angular/forms";
import { ButtonModule } from "primeng/button";

@UntilDestroy()
@Component({
  selector: "jni-workflow-email-attachments",
  templateUrl: "./workflow-email-attachments.component.html",
  styleUrls: ["./workflow-email-attachments.component.scss"],
  imports: [CommonModule, FileUploadModule, FormsModule, ButtonModule],
})
export class WorkflowEmailAttachmentsComponent {
  fileSizeInKb = 1024;
  filesObject: FileUploadDto[] = [];
  count = 1;
  totalFileSizeInKb = 0;
  fileAttachmentArray = new Map<string, string>();
  isDocusignLinkAttach = false;
  @Input() fileName = "";

  @ViewChild("fileEvent", { static: false })
  fileEvent!: ElementRef;
  @Output() attachmentFileArrayEvent = new EventEmitter();
  @Output() attachmentFileArrayUrlEvent = new EventEmitter<
    Map<string, string>
  >();

  @Output() TotalFileSizeEvent = new EventEmitter();
  @Output() docusignCheckEvent = new EventEmitter<boolean>();

  constructor(
    private _toastr: JniToastrService,
    private _poEmailAttachmentsService: ProjectWorkflowService,
    private _loaderService: LoaderService
  ) {}

  // async getAttachmentFile(file: any) {
  //   for (const key in file.target.files) {
  //     const fileObj = file.target.files[key];
  //     const filesize = Math.round(fileObj.size / this.fileSizeInKb);
  //     const fileSizeName = this.formatBytes(fileObj.size);
  //     const fileName = fileObj?.name;
  //     const fileextension = '.' + fileObj?.name?.split('.').pop().toLowerCase();
  //     if (filesize) {
  //       this.totalFileSizeInKb = this.totalFileSizeInKb + filesize;
  //       this.TotalFileSizeEvent.emit(this.totalFileSizeInKb);
  //       if (this.totalFileSizeInKb >= 33000) {
  //         this._toastr.error(
  //           `Total file attachments size must be less than 33MB`,
  //           'Error'
  //         );
  //         return;
  //       }
  //     }
  //     if (this.filesObject.length >= 250) {
  //       this._toastr.error(`File attachments must be less than 250`, 'Error');
  //       return;
  //     }
  //     await getBase64(fileObj).then((data) => {
  //       const b64String = data as string;
  //       this.createFileUploadDto(
  //         b64String,
  //         fileName,
  //         fileextension,
  //         filesize,
  //         fileObj.type,
  //         fileSizeName
  //       );
  //     });
  //   }
  // }

  getFileUrl(object: FileUploadDto) {
    this._loaderService.setLoaderState(true);
    this._poEmailAttachmentsService
      .getWorkflowEmailAttachmentUrl(object)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res?.data) {
            this.filesObject.push({
              base64: object.base64,
              fileName: object.fileName,
              fileExtension: object.fileExtension,
              fileSize: object.fileSize,
              fileMimeType: object.fileMimeType,
              fileId: this.count++,
              fileSizeName: object.fileSizeName,
            });
            this.fileAttachmentArray.set(object.fileName, res.data);
            this.attachmentFileArrayUrlEvent.emit(this.fileAttachmentArray);
            this.attachmentFileArrayEvent.emit(this.filesObject);
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  onFileClickRemove() {
    this.fileEvent.nativeElement.value = "";
  }

  formatBytes(bytes: number, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  createFileUploadDto(
    data: string,
    name: string,
    extension: string,
    size: number,
    filemimetype: string,
    fileSizeName: string
  ) {
    const base64File = data.split(",")[1];
    const object: FileUploadDto = {
      base64: base64File,
      fileName: name,
      fileExtension: extension,
      fileSize: size,
      fileMimeType: filemimetype,
      fileId: this.count++,
      fileSizeName: fileSizeName,
    };

    this.getFileUrl(object);
  }

  fileRemove(file: FileUploadDto) {
    if (file) {
      const fileObject = this.filesObject.indexOf(file);
      this.filesObject.splice(fileObject, 1);
      this.totalFileSizeInKb = this.totalFileSizeInKb - file.fileSize;
      this.fileAttachmentArray.delete(file.fileName);
      this.attachmentFileArrayUrlEvent.emit(this.fileAttachmentArray);
      this.TotalFileSizeEvent.emit(this.totalFileSizeInKb);
      this.attachmentFileArrayEvent.emit(this.filesObject);
    }
  }

  onViewAttachment(file: FileUploadDto) {
    if (file) {
      const blob = this.b64toBlob(file.base64, file.fileMimeType);
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl);
    }
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  onValueCheck() {
    this.isDocusignLinkAttach = !this.isDocusignLinkAttach;
    this.docusignCheckEvent.emit(this.isDocusignLinkAttach);
  }

  addProjectFile(event: FileUploadDto, fileUrl: string) {
    this._loaderService.setLoaderState(false);
    if (event) {
      this.totalFileSizeInKb = this.totalFileSizeInKb + event.fileSize;
      this.TotalFileSizeEvent.emit(this.totalFileSizeInKb);
      if (this.totalFileSizeInKb >= 33000) {
        this._toastr.error(
          `Total file attachments size must be less than 33MB`,
          "Error"
        );
        return;
      }

      if (this.filesObject.length >= 250) {
        this._toastr.error(`File attachments must be less than 250`, "Error");
        return;
      }

      if (this.filesObject.find(x => x.fileName === event.fileName)) {
        this._toastr.error(
          `File ${event.fileName} has already been added`,
          "Error"
        );
        return;
      }

      this.filesObject.push({
        base64: event.base64,
        fileName: event.fileName,
        fileExtension: event.fileExtension,
        fileSize: event.fileSize,
        fileMimeType: event.fileMimeType,
        fileId: this.count++,
        fileSizeName: event.fileSizeName,
      });

      this.fileAttachmentArray.set(event.fileName, fileUrl);
      //this.attachmentFileArrayUrlEvent.emit(this.fileAttachmentArray);
      this.attachmentFileArrayEvent.emit(this.filesObject);
    } else {
      this._toastr.error(`Error`, "Unable to Add Selected Project File");
      return;
    }
  }
}
